export default __webpack_public_path__ + "30b3bc109235ad67e22a64ab31deef3a.jpg";